function onlyDigits(value) {
    return (value || '').replace(/\D/g, '');
}

function timeoutFetch(url, opts = {}, ms = 1200) {
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), ms);
    return fetch(url, { ...opts, signal: controller.signal })
        .finally(() => clearTimeout(id));
}

async function fetchViaCep(cep) {
    const clean = onlyDigits(cep);
    try {
        const res = await timeoutFetch(`https://viacep.com.br/ws/${clean}/json/`, { method: 'GET' }, 1200);
        if (!res.ok) return null;
        const data = await res.json();
        if (data && data.erro) return null;
        return {
            street: data && data.logradouro ? data.logradouro : '',
            neighborhood: data && data.bairro ? data.bairro : '',
            city: data && data.localidade ? data.localidade : '',
            state: data && data.uf ? data.uf : '',
            postalCode: data && data.cep ? data.cep : clean,
        };
    } catch (_) {
        return null;
    }
}

async function fetchBrasilApi(cep) {
    const clean = onlyDigits(cep);
    try {
        const res = await timeoutFetch(`https://brasilapi.com.br/api/cep/v2/${clean}`, { method: 'GET' }, 1200);
        if (!res.ok) return null; // 404 cai aqui rapidamente
        const data = await res.json();
        return {
            street: data && data.street ? data.street : '',
            neighborhood: data && data.neighborhood ? data.neighborhood : '',
            city: data && data.city ? data.city : '',
            state: data && data.state ? data.state : '',
            postalCode: data && data.cep ? data.cep : clean,
        };
    } catch (_) {
        return null;
    }
}

async function fetchIbgeState() {
    try {
        const res = await timeoutFetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados`, { method: 'GET' }, 3000);
        if (!res.ok) return null;
        const data = await res.json();
        const formatted = data.map(estado => ({
            id: estado.id,
            sigla: estado.sigla,
            nome: estado.nome
        }));
        return { data: formatted };
    } catch (_) {
        return null;
    }
}

async function fetchBrasilApiState() {
    try {
        const res = await timeoutFetch(`https://brasilapi.com.br/api/ibge/uf/v1`, { method: 'GET' }, 3000);
        if (!res.ok) return null;
        const data = await res.json();
        return { data };
    } catch (_) {
        return null;
    }
}

async function fetchIbgeCity(sigla) {
    try {
        const res = await timeoutFetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${sigla}/municipios`, { method: 'GET' }, 3000);
        if (!res.ok) return null;
        const data = await res.json();
        const formatted = data.map(cidade => ({
            id: cidade.id,
            nome: cidade.nome
        }));
        return { data: formatted };
    } catch (_) {
        return null;
    }
}

async function fetchBrasilApiCity(sigla) {
    try {
        const res = await timeoutFetch(`https://brasilapi.com.br/api/ibge/municipios/v1/${sigla}`, { method: 'GET' }, 3000);
        if (!res.ok) return null;
        const data = await res.json();
        return { data };
    } catch (_) {
        return null;
    }
}

export async function fetchAddressByCep(cep) {
    const clean = onlyDigits(cep);
    if (clean.length !== 8) return null;

    return new Promise((resolve) => {
        let settled = false;

        const settleIfValid = (res) => {
            if (!settled && res) {
                settled = true;
                resolve(res);
            }
        };

        const overallTimeout = setTimeout(() => {
            if (!settled) {
                settled = true;
                resolve(null);
            }
        }, 1400);

        fetchViaCep(clean).then(settleIfValid);
        fetchBrasilApi(clean).then(settleIfValid);
    });
}

export async function fetchCitysByState(sigla) {
    return new Promise((resolve) => {
        let settled = false;

        const settleIfValid = (res) => {
            if (!settled && res) {
                settled = true;
                resolve(res);
            }
        };

        const overallTimeout = setTimeout(() => {
            if (!settled) {
                settled = true;
                resolve(null);
            }
        }, 4000);

        // Tenta IBGE direto primeiro
        fetchIbgeCity(sigla).then(settleIfValid);
        // Fallback para BrasilAPI se IBGE falhar
        fetchBrasilApiCity(sigla).then(settleIfValid);
    });
}

export async function fetchState() {
    return new Promise((resolve) => {
        let settled = false;

        const settleIfValid = (res) => {
            if (!settled && res) {
                settled = true;
                resolve(res);
            }
        };

        const overallTimeout = setTimeout(() => {
            if (!settled) {
                settled = true;
                resolve(null);
            }
        }, 4000);

        fetchIbgeState().then(settleIfValid);

        fetchBrasilApiState().then(settleIfValid);
    });
}